export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';
export const DEFAULT_DATETIME_FORMAT = 'yyyy-MM-dd hh:mm a';

export const DEFAULT_DATE_FORMAT_PLACEHOLDER = 'YYYY-MM-DD';
export const DEFAULT_DATETIME_FORMAT_PLACEHOLDER = 'YYYY-MM-DD hh:mm';
